<template>
  <div class="py-5 px-10">
    <v-badge
      v-if="differences.images && differences.images.main"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-card class="py-5 mb-6 text-center">
      <ImagePreview v-model="images.main.url" v-if="images.main">
        <template v-slot:activator>
          <v-img :src="images.main.url" height="150" contain></v-img>
        </template>
      </ImagePreview>

      <v-img
        v-else
        src="@/assets/logo_black_no_text.png"
        height="150"
        contain
      ></v-img>

      <div class=" mt-3 accent--text text-h6 font-weight-light">
        Main image <span v-if="rules.images && rules.images.main"> *</span>
        <!-- <span> {{ differences.images.main }}</span> -->
      </div>
      <div
        class="upload-file d-flex align-center justify-center align-content-center"
      >
        <FileInput
          name="main"
          :rules="rules.images && rules.images.main ? rules.images.main : []"
          v-if="isForm"
          @input="handleChange"
          accept="image/png, image/jpeg, image/webp"
          :readOnly="readOnly"
          label="Main image"
          clearable
          v-model="images.main"
          prepend-icon="mdi-image"
        />
      </div>
    </v-card>
    <v-badge
      v-if="differences.images && differences.images.bottle"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-card class="py-5 mb-6 text-center">
      <ImagePreview v-model="images.bottle.url" v-if="images.bottle">
        <template v-slot:activator>
          <v-img :src="images.bottle.url" height="150" contain></v-img>
        </template>
      </ImagePreview>
      <v-img
        v-else
        src="@/assets/logo_black_no_text.png"
        height="150"
        contain
      ></v-img>
      <div class="text-center mt-3 accent--text text-h6 font-weight-light">
        Bottle image
      </div>
      <div
        class="upload-file d-flex align-center justify-center align-content-center"
      >
        <FileInput
          name="bottle"
          :rules="
            rules.images && rules.images.bottle ? rules.images.bottle : []
          "
          v-if="isForm"
          validate-on-blur
          @input="handleChange"
          accept="image/png, image/jpeg, image/webp"
          :readOnly="readOnly"
          label="Bottle image"
          clearable
          v-model="images.bottle"
          prepend-icon="mdi-image"
        />
      </div>
    </v-card>
    <v-badge
      v-if="differences.images && differences.images.package"
      color="pink"
      icon="mdi-pencil"
      class="d-flex justify-end"
    ></v-badge>
    <v-card class="py-5 mb-6 text-center">
      <ImagePreview v-model="images.package.url" v-if="images.package">
        <template v-slot:activator>
          <v-img :src="images.package.url" height="150" contain></v-img>
        </template>
      </ImagePreview>
      <v-img
        v-else
        src="@/assets/logo_black_no_text.png"
        height="150"
        contain
      ></v-img>
      <div class="text-center mt-3 accent--text text-h6 font-weight-light">
        Package image
      </div>
      <div
        class="upload-file d-flex align-center justify-center align-content-center"
      >
        <FileInput
          name="package"
          :rules="
            rules.images && rules.images.package ? rules.images.package : []
          "
          validate-on-blur
          v-if="isForm"
          @input="handleChange"
          accept="image/png, image/jpeg, image/webp"
          :readOnly="readOnly"
          label="Package image"
          clearable
          v-model="images.package"
          prepend-icon="mdi-image"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import FileInput from "@/components/inputs/FileInput.vue"
export default {
  components: {
    FileInput,
    ImagePreview: () => import("@/components/perfumist/ImagePreview")
  },
  props: {
    value: {
      type: Object,
      default: () => ({ main: null, bottle: null, package: null })
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isForm: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Object,
      default: () => ({})
    },

    differences: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      images: {
        main: null,
        bottle: null,
        package: null
      }
    }
  },
  mounted() {
    this.patchWithValue(this.value)
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        this.patchWithValue(newValue)
      }
    }
  },
  methods: {
    patchWithValue(v) {
      if (!this.lo.isEqual(v, this.images)) this.images = this.lo.cloneDeep(v)
    },
    handleChange() {
      this.$emit("input", this.images)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-file {
  .v-input {
    max-width: 250px;
  }
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>
